module.exports = __webpack_public_path__ + "img/public/SiteIcons/pendingicon.svg?609f909d";